import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useSearchParams } from 'react-router-dom';

// Context Providers
import { AuthProvider } from './context/AuthContext';

// Auth Components
import LoginModal from './components/auth/LoginModal';
import ProtectedRoute from './components/auth/ProtectedRoute';

// Layout Components
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import MatrixRain from './components/layout/MatrixRain';

// Pages
import Home from './pages/Home';
import Events from './pages/Events';
import EventDetails from './pages/EventDetails';
import SecretEventPage from './pages/SecretEventPage';
import Products from './pages/Products';
import ProductDetails from './pages/ProductDetails';
import Artists from './pages/Artists';
import Gallery from './pages/Gallery';
import Subscribe from './pages/Subscribe';
import About from './pages/About';
import Contact from './pages/Contact';
import Messages from './pages/Messages';
import VenuePortfolio from './pages/VenuePortfolio';
import Calendar from './pages/Calendar';
import Profile from './pages/Profile';
import Scanner from './pages/Scanner';
import RSVPScan from './pages/RSVPScan';
import LocationRevealAdmin from './pages/LocationRevealAdmin';
import LiveStream from './pages/LiveStream';
import StreamRecording from './pages/StreamRecording';

// Styles
import './App.css';

// Component to handle login modal from URL params
function AppContent() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [showLoginModal, setShowLoginModal] = useState(false);

  useEffect(() => {
    if (searchParams.get('login') === 'true') {
      setShowLoginModal(true);
    }
  }, [searchParams]);

  const handleCloseLogin = () => {
    setShowLoginModal(false);
    setSearchParams({});
  };

  return (
    <div className="App">
      {/* Matrix Rain Background Effect */}
      <MatrixRain />
      
      {/* Navigation */}
      <Navbar />
      
      {/* Main Content */}
      <main className="App-content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/events" element={<Events />} />
          <Route path="/events/:id" element={<EventDetails />} />
          <Route path="/event/:code" element={<SecretEventPage />} />
          <Route path="/products" element={<Products />} />
          <Route path="/products/:id" element={<ProductDetails />} />
          <Route path="/artists" element={<Artists />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/subscribe" element={<Subscribe />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/venue-portfolio" element={<VenuePortfolio />} />
          
          {/* Protected Messages Route - Requires Login */}
          <Route 
            path="/messages" 
            element={
              <ProtectedRoute>
                <Messages />
              </ProtectedRoute>
            } 
          />
          
          {/* Protected Calendar Route - Requires Login */}
          <Route 
            path="/calendar" 
            element={
              <ProtectedRoute>
                <Calendar />
              </ProtectedRoute>
            } 
          />
          
          {/* Protected Profile Route - Requires Login */}
          <Route 
            path="/profile" 
            element={
              <ProtectedRoute>
                <Profile />
              </ProtectedRoute>
            } 
          />
          
          {/* Protected Scanner Route - Requires Login */}
          <Route 
            path="/scanner" 
            element={
              <ProtectedRoute>
                <Scanner />
              </ProtectedRoute>
            } 
          />
          
          {/* RSVP Scan Route - Public (from QR code) */}
          <Route path="/rsvp/:eventId" element={<RSVPScan />} />
          
          {/* Protected Location Reveal Admin Route */}
          <Route 
            path="/events/:eventId/location-reveal" 
            element={
              <ProtectedRoute>
                <LocationRevealAdmin />
              </ProtectedRoute>
            } 
          />
          
          {/* Live Stream Route - Public */}
          <Route path="/stream/:streamId" element={<LiveStream />} />
          
          {/* Stream Recording Route - Public */}
          <Route path="/stream/recording/:recordingId" element={<StreamRecording />} />
        </Routes>
      </main>
      
      {/* Footer */}
      <Footer />
      
      {/* Login Modal */}
      <LoginModal isOpen={showLoginModal} onClose={handleCloseLogin} />
    </div>
  );
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </Router>
  );
}

export default App;

